import ky from 'ky';

/**
 * Impersonation used to be added here as a `Content-Language` header read from
 * local storage. It is now the session itself, so there is nothing to attach:
 * the cookie already names the user every request should act as, and it names
 * the same one to BetterAuth's routes as to ours.
 */
const configureAPI = (prefixUrl: string) =>
  ky.extend({
    prefixUrl,
    timeout: 60 * 1000,
    credentials: 'include', // Include cookies for better-auth session management
  });

export default configureAPI;
